import { HttpClient } from '@angular/common/http';
import { cmsApi } from '../constants/constants';
import { oneAssetApi } from '../constants/constants';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var FundService = /** @class */ (function () {
    function FundService(http) {
        this.http = http;
        this._FundWithFundTypeUrl = oneAssetApi + '/Fund/GetNAVDaily';
    }
    FundService.prototype.getTopFund = function () {
        var URL = cmsApi + '/get_fund_recomend';
        var body = {};
        return this.http.post(URL, body);
    };
    FundService.prototype.getAllFund = function () {
        var URL = cmsApi + '/get_fund_all';
        var body = {};
        return this.http.post(URL, body);
    };
    FundService.prototype.get_fundByName = function (name) {
        var URL = cmsApi + '/get_fundByName';
        var body = { name: name };
        return this.http.post(URL, body);
    };
    FundService.prototype.getFundIncludeFundType = function () {
        return this.http.get(this._FundWithFundTypeUrl);
    };
    FundService.prototype.getFundByTypeId = function (typeId) {
        var URL = cmsApi + '/get_fundByType';
        var body = {
            fundtype: typeId
        };
        return this.http.post(URL, body);
    };
    FundService.prototype.getFundInfo = function (fundInfoId) {
        var URL = oneAssetApi + '/Fund/GetInfo';
        var body = {
            fundId: fundInfoId
        };
        // console.log("getFundInfo body ", body);
        return this.http.post(URL, body);
    };
    FundService.prototype.getIIV = function () {
        var URL = oneAssetApi + '/info/GetIIV';
        return this.http.get(URL);
    };
    FundService.prototype.GetNAVHistory = function (fundId, fundCode) {
        var URL = oneAssetApi + '/Fund/GetNAVHistory';
        var body = {
            fundId: fundId,
            fundCode: fundCode
        };
        return this.http.post(URL, body);
    };
    FundService.prototype.getDevidendHistory = function (fundId) {
        var URL = oneAssetApi + '/Fund/GetWebFundInfoDivided';
        var body = {
            fundId: fundId
        };
        // console.log("getDevidendHistory ", body);
        return this.http.post(URL, body);
    };
    FundService.prototype.Graph = function (fundId, index) {
        var URL = oneAssetApi + '/Performance/Graph';
        var body = {
            fundId: fundId,
            index: index
        };
        return this.http.post(URL, body);
    };
    FundService.prototype.GetNAVBasket = function (FundId, date) {
        var URL = oneAssetApi + '/ETF/GetNAVBasket';
        var body = {
            FundId: FundId,
            date: date
        };
        return this.http.post(URL, body);
    };
    FundService.prototype.GetPDFBasket = function (FundId, date) {
        var URL = oneAssetApi + '/ETF/GetPDFBasket';
        var body = {
            FundId: FundId,
            date: date
        };
        // console.log(body);
        return this.http.post(URL, body);
    };
    FundService.prototype.getFundByFundId_Currency = function (FundId, currency) {
        var URL = cmsApi + '/getFundByFundId_Currency';
        var body = {
            FundId: FundId,
            currency: currency
        };
        return this.http.post(URL, body);
    };
    FundService.prototype.getFundDoc = function (fundId) {
        var URL = cmsApi + '/getDocByFundId2';
        var body = { id: fundId };
        // console.log(body);
        return this.http.post(URL, body);
    };
    FundService.prototype.getFundDocEN = function (fundId) {
        var URL = cmsApi + '/getDocByFundId2_en';
        var body = { id: fundId };
        // console.log(body);
        return this.http.post(URL, body);
    };
    FundService.prototype.getFundDocPrivate = function () {
        var URL = cmsApi + '/getDocumentPrivate_front';
        var body = { docName: '', IsActive: 'y' };
        // console.log(body);
        return this.http.post(URL, body);
    };
    FundService.prototype.getFundDocProvident = function () {
        var URL = cmsApi + '/getDocumentProvident_front';
        var body = { docName: '', IsActive: 'y' };
        // console.log(body);
        return this.http.post(URL, body);
    };
    FundService.prototype.getNavMovement = function (fundId, index, fundCode) {
        var URL = oneAssetApi + '/Fund/NAVMovement';
        var body = {
            fundId: fundId,
            index: index,
            fundCode: fundCode
        };
        return this.http.post(URL, body);
    };
    FundService.prototype.getNavMovement_2 = function (fundId) {
        var URL = oneAssetApi + '/Fund/NAVMovement';
        var body = {
            fundId: fundId,
            fundcode: 'ONE-STOXXASEAN_USD',
            index: 3
        };
        return this.http.post(URL, body);
    };
    FundService.prototype.getCalendar = function (fundId) {
        var URL = cmsApi + '/getDocByFundId2_calendar';
        var body = { id: fundId };
        return this.http.post(URL, body);
    };
    FundService.ngInjectableDef = i0.defineInjectable({ factory: function FundService_Factory() { return new FundService(i0.inject(i1.HttpClient)); }, token: FundService, providedIn: "root" });
    return FundService;
}());
export { FundService };
